import { undoubleSortList } from './../../../utils/undouble-sort-list';
import { ITaxDetails } from 'src/app/models/registration/taxDetails';
import { InvestorFacade } from 'src/app/store/investor/facade/investor.facade';
import { KeyValue } from '@angular/common';
import { TaxRateType, ITaxRateSchedule, ITaxRateSelectOption, IMappedTaxRateSchedule } from './../../../models/tax';
import { EntityLegalType } from './../../../models/entity';
import { UtilitiesService } from './../../../services/http/utilities.service';
import { UtilitiesActions, LoadTaxRateScheduleList } from './../actions/utilities.actions';
import { Country } from './../../../models/country';
import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { tap, map, delay, switchMap, withLatestFrom } from 'rxjs/operators';
import * as utilitiesActions from '../actions/utilities.actions';

@Injectable()
export class UtilitiesEffects {
    constructor(
        private actions$: Actions,
        private utilitiesService: UtilitiesService,
        private investorFacade: InvestorFacade) { }


    GetCountryList$ = createEffect(() => {
        return this.actions$.pipe(
            ofType<utilitiesActions.LoadCountryList>(utilitiesActions.GET_COUNTRY_LIST),
            switchMap(() => {
                return this.utilitiesService.loadCountries()
                    .pipe(
                        map((res: any) => {
                            return new utilitiesActions.LoadCountryListSuccess(res);
                        })
                    );
            }));
    });


    GetTaxRateSchedule$ = createEffect(() => {
        return this.actions$.pipe(
            ofType<utilitiesActions.LoadTaxRateScheduleList>(utilitiesActions.GET_TAX_RATE_SCHEDULE_LIST),
            withLatestFrom(this.investorFacade.investorTaxDetails$),
            switchMap((v: [LoadTaxRateScheduleList, ITaxDetails]) => {
                const [action, taxDetails] = v;
                return this.utilitiesService.loadTaxRateSchedule(<EntityLegalType>action.payload)
                    .pipe(
                        map((res: ITaxRateSchedule[]) => {
                            const countryTaxResidency: string | number = taxDetails.countryTaxResidency;
                            const taxType = (countryTaxResidency && (countryTaxResidency === 'New Zealand' || countryTaxResidency === 554)) ? TaxRateType.RWT : TaxRateType.NRWT;
                            let RWTTaxRateSchedule: KeyValue<string, number>[] = res.filter((trs) => {
                                return trs.taxRateType === taxType;
                            }).map((r: ITaxRateSchedule) => {
                                return this.taxRateScheduleKeyValueMapper(r);
                            });

                            RWTTaxRateSchedule = undoubleSortList(RWTTaxRateSchedule, 'value'); // undouble duplicate values and sort list

                            let PIRTaxRateSchedule: KeyValue<string, number>[] = res.filter((trs) => {
                                return trs.taxRateType === TaxRateType.PIE;
                            }).map((r: ITaxRateSchedule) => {
                                return this.taxRateScheduleKeyValueMapper(r);
                            });

                            PIRTaxRateSchedule = undoubleSortList(PIRTaxRateSchedule, 'value'); // undouble duplicate values and sort list

                            const taxRateSchedulePayload: IMappedTaxRateSchedule = {
                                RWTTaxRateSchedule,
                                PIRTaxRateSchedule
                            };
                            return new utilitiesActions.LoadTaxRateScheduleListSuccess(taxRateSchedulePayload);
                        })
                    );
            })
        );
    });


    taxRateScheduleKeyValueMapper(r: ITaxRateSchedule) {
        const taxRate: ITaxRateSelectOption = {
            key: r.taxRatePercentage + '%',
            value: r.taxRate,
            isDefault: r.isDefault
        };
        return taxRate;
    }


}
